let accordionCollection = document.getElementsByClassName("cav-accordion");

for (const accordion of accordionCollection) {
  const accordionItemCollection =
    accordion.getElementsByClassName("cav-accordion-item");

  for (const accordionItem of accordionItemCollection) {
    const accordionIcon = accordionItem.getElementsByClassName("cav-icon")[0];
    accordionIcon.classList.remove("cav-icon--minus");
    accordionIcon.classList.add("cav-icon--plus");
    accordionItem.classList.remove("cav-active");

    accordionItem
      .getElementsByTagName("button")[0]
      .addEventListener("click", (event) => {
        event.preventDefault();

        for (const child of [...accordionItem.parentElement.children]) {
          if (child !== accordionItem) {
            child.classList.remove("cav-active");
            child.getElementsByClassName("cav-icon")[0].classList.remove("cav-icon--minus");
            child.getElementsByClassName("cav-icon")[0].classList.remove("cav-icon--plus");
            child.getElementsByClassName("cav-icon")[0].classList.add("cav-icon--plus");
          }
        }

        accordionItem.classList.toggle("cav-active");
        accordionIcon.classList.toggle("cav-icon--minus");
        accordionIcon.classList.toggle("cav-icon--plus");
      });
  }
}
